import { Component, Output, EventEmitter, inject } from '@angular/core';
import { MethodApi } from '../../../api/api-request';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Discount, IDiscount } from '@co-assist/library';

@Component({
    selector: 'app-discount-code',
    templateUrl: './discount-code.component.html',
    styleUrls: ['./discount-code.component.scss'],
    standalone: false
})
export class DiscountCodeComponent {
    private api = inject(MethodApi);
    private toastr = inject(ToastrService);
    private translate = inject(TranslateService);

    @Output() emittedValue: EventEmitter<any> = new EventEmitter<any>();
    discount: Discount;
    inputPromotionnalCode: string;

    validate() {
        this.api.getDiscountCodeValidity({ name: this.inputPromotionnalCode }).subscribe((response: IDiscount) => {
            if (response) {
                this.discount = new Discount(response);
            }
            if (this.discount?.isApplicable()) {
                this.emittedValue.emit(this.discount);
            } else {
                this.toastr.error(this.translate.instant('DISCOUNT_CODE.TOAST.INVALID_CODE'));
            }
        }, () => {
            this.toastr.error(this.translate.instant('DISCOUNT_CODE.TOAST.INVALID_CODE'));
        });
    }
}
